import EdoNewFund from "./EdoNewFund";

export default EdoNewFund;
